import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { IInvoice } from '@care-portals/api-interfaces';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Observable, firstValueFrom } from 'rxjs';
import { InvoiceFacade } from '../../../+store/invoice/invoice.facade';
import { APIService } from '../../../services/api/api.service';
import {
  NzNotificationModule,
  NzNotificationService
} from 'ng-zorro-antd/notification';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';

@Component({
  selector: 'portals-provider-invoice-preview',
  templateUrl: './invoice-preview.component.html',
  styleUrls: ['./invoice-preview.component.less'],
  host: {
    wrapper: 'yes'
  },
  standalone: true,
  // encapsulation: ViewEncapsulation.None,
  imports: [
    NzLayoutModule,
    CommonModule,
    NzToolTipModule,
    NzNotificationModule,
    NzButtonModule,
    NzModalModule,
    NzInputModule,
    ReactiveFormsModule,
    NzFormModule
  ]
})
export class InvoicePreviewComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() invoice: IInvoice;
  loading$: Observable<boolean>;
  isActive = true;
  isTemplateMissing = false;
  isVisible = false;
  emailControl = new FormControl<string>('', [
    Validators.required,
    Validators.email
  ]);

  @ViewChild('htmlViewer') htmlViewer: ElementRef;
  html;
  constructor(
    private invoiceFacade: InvoiceFacade,
    private readonly apiService: APIService,
    private readonly notificationService: NzNotificationService
  ) {}

  ngOnInit(): void {
    this.isActive = true;
    this.loading$ = this.invoiceFacade.loading$;
  }

  ngAfterViewInit() {
    // TODO move this to a ngrx store
    this.apiService.getInvoiceEmailTemplate(this.invoice.id).subscribe(res => {
      if (res.html) {
        this.html = res.html;
        this.loadHtmlToViewer(this.html);
      } else {
        this.isTemplateMissing = true;
      }
    });
  }

  loadHtmlToViewer(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    this.htmlViewer.nativeElement.appendChild(
      doc.getElementsByTagName('body')[0]
    );
  }

  ngOnDestroy(): void {
    this.isActive = false;
  }

  getPaymentDetails(payment_intent) {
    if (payment_intent?.charges?.data?.length > 0) {
      const card = payment_intent.charges.data[0].payment_method_details.card;

      return `brand: ${card.brand}, last 4 digits: ${card.last4}, expiry date: ${card.exp_year}/${card.exp_month}`;
    }

    return '';
  }

  openWindow() {
    var newWin = open('url', 'Invoice', 'height=1000,width=800');
    newWin.document.write(this.htmlViewer.nativeElement.innerHTML);
  }

  emailToPatient(email: string) {
    return firstValueFrom(
      this.apiService.sendInvoiceToPatient(this.invoice.id, email)
    )
      .then(res => {
        this.notificationService.success('Sent Successfully', '');
      })
      .catch(err => {
        console.error(err);
        this.notificationService.error('Failed', err.message);
      });
  }

  confirmEmailToPatient() {
    this.emailControl.setValue(this.invoice.customer_email || '');
    this.isVisible = true;
  }

  handleOk() {
    if (this.emailControl.valid) {
      this.emailToPatient(this.emailControl.value);
      this.isVisible = false;
    } else {
      this.emailControl.markAsDirty();
      this.emailControl.updateValueAndValidity();
    }
  }

  handleCancel() {
    this.isVisible = false;
  }
}
